import Icon from '../icon/Icon';
import type { IconId } from '../icon/icons';
import './ActionList.less';

export type ActionListItem<T extends string> = {
    id: T;
    label: string;
    iconId?: IconId;
};

export type ActionListProps<T extends string> = {
    items: ActionListItem<T>[];
    onClick: (event: MouseEvent, item: ActionListItem<T>) => void;
};

function ActionList<T extends string>({ items, onClick }: ActionListProps<T>) {
    return (
        <div className={`bri-ActionList`}>
            {items.map(item => (
                <button
                    type="button"
                    key={item.id}
                    className={`bri-ActionList-item bri-Body2Font`}
                    onClick={event => onClick(event, item)}
                >
                    {item.iconId && <Icon iconId={item.iconId} size="small" />}
                    {item.label}
                </button>
            ))}
        </div>
    );
}

export default ActionList;
